import { createSlice } from '@reduxjs/toolkit';
import { TableData } from '@uikit/Tables/types';
import { payorsApi } from '@store/rtk/payors';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type exclusionsSliceType = {
  exclusionsContractorsTableData: TableData;
};

const { exclusionsContractorsTableColumns } = TABLE_COLUMNS;

const initialState: exclusionsSliceType = {
  exclusionsContractorsTableData: {
    columns: exclusionsContractorsTableColumns,
    rows: [
      {
        id: 1,
        effective: '05/01/2024',
        expiration: '05/30/2025',
        contractor: 'ABC Transportation',
        type: 'Excluded',
        reason: 'Smashed my hand in do...',
        requester: 'Ike Turner',
      },
      {
        id: 2,
        effective: '04/01/2024',
        expiration: '04/30/2025',
        contractor: 'DEF Transportation',
        type: 'Preferred',
        reason: 'Always on time for pati...',
        requester: 'Bob Hope',
      },
      {
        id: 3,
        effective: '05/01/2022',
        expiration: '04/30/2024',
        contractor: 'HIJ Transportation',
        type: 'Preferred',
        reason: 'Clean vehicles, timely pic...',
        requester: 'Tasha Smith',
      },
    ],
  },
};

export const exclusionContractorsSlice = createSlice({
  name: 'exclusionContractors',
  initialState,
  reducers: {
    // Define your reducers here
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      payorsApi.endpoints.getExcludedContractors.matchFulfilled,
      (state, { payload }) => {
        state.exclusionsContractorsTableData = {
          ...state.exclusionsContractorsTableData,
          ...payload,
          requestTablePageChange: payorsApi.endpoints.getExcludedContractors,
        };
        // TODO: fill state when request will gives right data
      }
    );
  },
});

export const selectExclusionContractors = (state: {
  exclusionContractors: exclusionsSliceType;
}) => state.exclusionContractors;
export const exclusionContractorsReducer = exclusionContractorsSlice.reducer;
